module.exports = __webpack_public_path__ + "img/25_70.824aad0a.png";